import React, {useMemo}  from 'react'
import {expandReference, deadlineObjectChecker } from '../../lib/utils';
import {ViewLabelValueField,VisDiv } from '../../components';
import {useStateContext} from '../../context/StateContext';

import {DataScadenzaManuale} from '../../lib/ScadenzeData'


/**
 * Component to display deadlines for a device with Scadenza Manuale deadlines
 * #deadlines 
 * @param {object} device - The device object
 * @param {object} deviceTemplate - The device template object
 * @param {object} registerTemplate - The register template object
 * 
 * @returns {JSX.Element} A JSX element displaying the deadlines
 */
const ScadenzaManuale = ({device, deviceTemplate, registerTemplate}) => {

    const testing = false
    const data = useMemo(() => (DataScadenzaManuale(device, deviceTemplate, registerTemplate)),[device, deviceTemplate, registerTemplate]);

    const {expiry, collaudo, maintenanceTasksList} = data
    const exists = [!!expiry?.date].some?.(x=>x==true)
    const testFunction = () => {
        //console.log(DataScadenzaManuale(device, deviceTemplate, registerTemplate))
        console.log("Scadenza Manuale")
    }

        return (
            <div>
                <VisDiv rules={[testing]}><button onClick={()=>{testFunction()}}>Test deadlines</button></VisDiv>
                { collaudo?.date &&
                <ViewLabelValueField
                    label={collaudo.label}
                    value={ deadlineObjectChecker(collaudo?.dateObject).date}
                    highlight={ deadlineObjectChecker(collaudo?.dateObject).color}
                />}
                { expiry?.date &&
                <ViewLabelValueField
                    label={expiry.label}
                    value={deadlineObjectChecker(expiry.dateObject).date}
                    highlight={deadlineObjectChecker(expiry.dateObject).color}
                /> }

            </div>
        )
    

}

export default ScadenzaManuale
